import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const CheckmarkIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" {...props}>
        <path fill={color || "currentColor"} d="M5.146 5.316 10.737 0l1.75 1.84-7.431 7.067L.001 3.59l1.84-1.75 3.305 3.476z"/>
    </svg>
);

export default CheckmarkIcon;